module.exports = __webpack_public_path__ + "img/orders20.349596d1.png";